// module
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

NavButton.propTypes ={
    buttonName: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired
}

function NavButton({buttonName, to}){
    return (
        <Link className="nav_button" to={to}><button className="nav_button">{buttonName}</button></Link>
    );
}

export default NavButton;